import { Card, Grid } from '@mui/material';

import { selectTopicsGlobaScoreDataForProject } from '@/domain/impact-calculate/impact-calculate.selectors';
import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import { LoadingView } from '@/ui/components/LoadingView';
import { useAppSelector } from '@/ui/hook/store';

import { NoProjectMessage } from './NoProjectMessage';
import { ProjectCard } from './ProjectCard';

export function ProjectsPageList({
  projectItems,
  isFetchingProjects,
  onClickProject,
  noProjectMessage,
  createButton,
}: {
  projectItems: ProjectAbstract[];
  isFetchingProjects: boolean;
  onClickProject: (projectId: number) => void;
  noProjectMessage: string;
  createButton: React.ReactNode;
}) {
  const isProjectItemsEmpty = projectItems.length === 0;
  return (
    <>
      {isFetchingProjects ? (
        <LoadingView />
      ) : (
        <>
          {isProjectItemsEmpty && (
            <NoProjectMessage
              message={noProjectMessage}
              buttonNewProject={createButton}
            />
          )}
          <ProjectsList
            projects={projectItems}
            onClickProject={onClickProject}
          />
        </>
      )}
    </>
  );
}

export function ProjectsList({
  projects,
  onClickProject,
}: {
  projects: ProjectAbstract[];
  onClickProject: (projectId: number) => void;
}) {
  return (
    <Grid container spacing={3}>
      {projects.length !== 0 ? (
        <>
          {projects.map((project) => (
            <ProjectView
              key={project.id}
              project={project}
              onClickProject={onClickProject}
            />
          ))}
        </>
      ) : (
        <SkeletonEmtpy />
      )}
    </Grid>
  );
}

function ProjectView({
  project,
  onClickProject,
}: {
  project: ProjectAbstract;
  onClickProject: (projectId: number) => void;
}) {
  const topicsGlobalScoreData = useAppSelector(
    selectTopicsGlobaScoreDataForProject(project?.id || -1),
  );

  return (
    <Grid key={project.id} item xs={12} md={6} xl={4}>
      <ProjectCard
        project={project}
        topicsGlobalScoreData={topicsGlobalScoreData}
        onClick={() => onClickProject(project.id)}
      />
    </Grid>
  );
}

function SkeletonEmtpy() {
  return (
    <>
      {[...Array(6)].map((_, index) => (
        <Grid key={'skeleton' + index} item xs={12} lg={6} xl={4}>
          <Card
            sx={{
              minHeight: 300,
              height: 300,
              borderRadius: 3,
            }}
          ></Card>
        </Grid>
      ))}
    </>
  );
}
